export const contact = {
  name: 'DACB',
  baseline: "Dessin d'architecture — Cindie Bonnel",
  address: '235 rue du centre, St Didier sous Riverie',
  city: '69440 Chabanière',
  phone: '+33 (0)6 69 56 63 87',
  phoneHref: 'tel:+33669566387',
  email: 'cindie.bonnel@dacb.fr',
}

export const navigation = [
  { label: 'À propos', to: '/a-propos' },
  { label: 'Projets', to: '/projets' },
  { label: 'Services', to: '/services' },
  { label: 'Contact', to: '/contact' },
]

export type Project = {
  title: string
  category: string
  description: string
  image: string
  year: string
}

export const projects: Project[] = [
  {
    title: "Architecture d'intérieur",
    category: 'Aménagement',
    description: "Projet d'aménagement d'intérieur au style contemporain, retravaillé pièce par pièce.",
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/99a24ac8-1516-45b0-82d2-dea929d29a68.jpg',
    year: '2024',
  },
  {
    title: 'Avant-projet',
    category: 'Neuf',
    description: "Avant-projet d'une villa contemporaine, du relevé du terrain aux volumes définitifs.",
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/96aa45b8-fef3-4f21-a465-a7facb43b7c0.jpg',
    year: '2024',
  },
  {
    title: 'Permis de construire',
    category: 'Urbanisme',
    description: "Image de synthèse et dossier complet déposé pour le projet d'un de nos clients.",
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/cb990001-594c-4af2-a5f7-954bf7931971.jpg',
    year: '2023',
  },
  {
    title: 'Rénovation',
    category: 'Existant',
    description: "Réhabilitation d'une maison en pierre : redistribution complète et ouverture des espaces.",
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c34c17f1-affb-44a7-aabd-75b8ae2ad202.jpg',
    year: '2023',
  },
]

export const heroImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/e2d2f748-4f4f-41f1-8954-0f074fb55edc.jpg'

export const phases = [
  {
    title: 'État des lieux',
    text: "Relevé de l'existant, prise de côtes sur site, puis retranscription de la phase initiale : un bon état des lieux est indispensable à la conception d'un projet concret et réalisable.",
  },
  {
    title: 'Esquisse',
    text: "D'après un état des lieux en rénovation, ou d'après les règlements d'urbanisme en neuf, l'esquisse est le premier jet de votre projet.",
  },
  {
    title: 'Avant-projet',
    text: "Plus abouti qu'une esquisse, et ayant déjà pris en compte les contraintes techniques, l'avant-projet est la version qui donne vie à vos idées.",
  },
]

export const services = [
  {
    title: 'Avant-projet',
    text: "Plus abouti qu'une esquisse, et ayant déjà pris en compte les contraintes techniques, l'avant-projet est la version qui donne vie à vos idées.",
    meta: 'Neuf & rénovation',
  },
  {
    title: 'Déclaration préalable & permis de construire',
    text: "Presque tous les projets nécessitent une autorisation d'urbanisme. Le dossier complet et le suivi de l'instruction sont un passage obligé de chaque dossier.",
    meta: 'Urbanisme',
  },
  {
    title: 'Dossier de consultation des entreprises',
    text: "Une fois l'autorisation d'urbanisme acquise, la phase DCE consiste à réaliser les plans techniques qui permettront aux bureaux d'étude ou artisans de délivrer leurs offres de prix.",
    meta: 'Phase technique',
  },
  {
    title: 'Suivi de travaux',
    text: "Pour certains dossiers de rénovation ou d'architecture d'intérieur, je peux également vous accompagner dans la réalisation de vos travaux.",
    meta: 'Chantier',
  },
]

export const partners = ['Bureaux d’étude', 'Artisans locaux', 'Maîtres d’œuvre', 'Constructeurs', 'Géomètres']
